<div [@routerTransition]>
    <sub-header [title]="'PurchaseOrders' | localize" >
        <div role="actions">
            <div class="btn-group" dropdown placement="button right">
                <button
                    id="dropdownButtonExcelOperations"
                    dropdownToggle
                    type="button"
                    class="btn btn-outline btn-outline-success btn-active-light-success dropdown-toggle me-1"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    aria-controls="dropdownMenuExcelOperations"
                >
                    <i class="far fa-file-excel btn-md-icon"></i>
                    <span class="d-none d-md-inline-block">
                        {{ 'ExcelOperations' | localize }}
                    </span>
                </button>
                <ul
                    id="dropdownMenuExcelOperations"
                    class="dropdown-menu dropdown-menu-right dropdown-excel-operations"
                    role="menu"
                    *dropdownMenu
                    aria-labelledby="dropdownButtonExcelOperations"
                >
                    <li role="menuitem">
                        <a
                            class="dropdown-item text-gray-900"
                            id="ExportPurchaseOrdersToExcelButton"
                            (click)="this.showExcelColumnSelectionModal()"
                            href="javascript:;"
                        >
                            <i class="fa fa-download me-2 mt-1 text-gray-900" style="font-size: 1rem"></i>
                            {{ 'ExportToExcel' | localize }}
                        </a>
                    </li>

                    <li *ngIf="'Pages.PurchaseOrders.Create' | permission" role="menuitem">
                        <a href="javascript:;" class="no-padding">
                            <span class="fileinput-button">
                                <p-fileUpload
                                    mode="basic"
                                    customUpload="true"
                                    name="ExcelFileUpload"
                                    #ExcelFileUpload
                                    maxFileSize="10000000"
                                    auto="auto"
                                    accept=".csv,.xls,.xlsx"
                                    (uploadHandler)="uploadExcel($event)"
                                    (onError)="onUploadExcelError()"
                                    chooseLabel="{{ 'ImportFromExcel' | localize }}"
                                ></p-fileUpload>
                            </span>
                        </a>
                    </li>
                </ul>
            </div>

            <button
                id="btn_create_purchaseOrder"
                *ngIf="'Pages.PurchaseOrders.Create' | permission"
                (click)="createPurchaseOrder()"
                class="btn btn-primary blue"
            >
                <i class="fa fa-plus"></i>
                {{ l('CreateNewPurchaseOrder') }}
            </button>
        </div>
    </sub-header>

    <div >
        <div class="card ">
            <div class="card-body">
                <form>
                    <div>
                        <div class="row">
                            <div class="col-md-3">
                                <select name="vendorId" [(ngModel)]="vendorId"
                                        (change)="getPurchaseOrders($event)"
                                        class="form-select">
                                    <option value="0">{{ l('SelectAVendor') }}</option>

                                    <option *ngFor="let item of allvendors" value="{{ item.id }}">
                                        {{ item.displayName }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                    <div class="input-group mb-3">
                                        <input [(ngModel)]="pNo"
                                                name="pNo"
                                                autoFocus
                                                type="text"
                                                class="form-control"
                                                [placeholder]="l('PONo')" />
                                    </div>
                            </div>
                            <div class="col-md-3">
                                    <div class="input-group mb-3">
                                        <input [(ngModel)]="referenceNo"
                                                name="referenceNo"
                                                autoFocus
                                                type="text"
                                                class="form-control"
                                                [placeholder]="l('ReferenceNo')" />
                                    </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label class="form-check form-check-custom form-check-solid">
                                    <input id="DateRange"
                                           #Product_IsActive="ngModel"
                                           name="DateRange"
                                           [(ngModel)]="dateRangeSelected"
                                           (click)="OnselectDateRange($event)"
                                           type="checkbox"
                                           class="form-check-input" />
                                    <span class="form-check-label">
                                        {{ l('DateRange') }}
                                    </span>
                                </label>
                            </div>
                            <div class="col-md-3" *ngIf="dateRangeSelected">
                                    <p-calendar [(ngModel)]="dateRange"
                                                selectionMode="range"
                                                dateFormat="yy-mm-dd"
                                                inputStyleClass="form-control">
                                    </p-calendar>
                            </div>
                            <div class="col-md-3">
                                        <select name="vendorId" [(ngModel)]="OrderStatus"
                                                (change)="getPurchaseOrders($event)"
                                                class="form-select">
                                            <option value="0">{{ l('All') }}</option>

                                            <option *ngFor="let item of allStatus" value="{{ item.id }}">
                                                {{ item.displayName }}
                                            </option>
                                        </select>
                            </div>
                            <div class="col-md-3">
                                    <button class="btn btn-default btn-primary blue btn-sm" type="submit" (click)="getPurchaseOrders($event)">
                                        Refresh
                                    </button>
                                    &nbsp;&nbsp;&nbsp;
                                    <button id="btn-reset-filters" class="btn btn-secondary btn-sm" (click)="getPurchaseOrders($event)"> Reset </button>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table
                            #dataTable
                            (onLazyLoad)="getPurchaseOrders($event)"
                            [value]="primengTableHelper.records"
                            rows="{{ primengTableHelper.defaultRecordsCountPerPage }}"
                            [paginator]="false"
                            tableStyleClass="table table-bordered table-hover"
                            [lazy]="true"
                            [scrollable]="true"
                            ScrollWidth="100%"
                            [tableStyle]="{ 'min-width': '50rem' }"
                            [resizableColumns]="primengTableHelper.resizableColumns"
                        >
                            <ng-template pTemplate="header">
                                <tr>
                                    <th
                                        style="width: 5%"
                                        [hidden]="
                                            !isGrantedAny('Pages.PurchaseOrders.Edit', 'Pages.PurchaseOrders.Delete')
                                        "
                                    >
                                        {{ l('Actions') }}
                                    </th>
                                    <th style="width: 120px" pSortableColumn="pNo">
                                        {{ l('OrderNo') }}
                                        <p-sortIcon field="purchaseOrder.pNo"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="pDate">
                                        {{ l('PDate') }}
                                        <p-sortIcon field="purchaseOrder.pDate"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="vendorFk.displayProperty">
                                        {{ l('Vendor') }}
                                        <p-sortIcon field="vendorDisplayProperty"></p-sortIcon>
                                    </th>                                    

                                    <th style="width: 150px" pSortableColumn="referenceNo">
                                        {{ l('ReferenceNo') }}
                                        <p-sortIcon field="purchaseOrder.referenceNo"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="subTotal">
                                        {{ l('PSubTotal') }}
                                        <p-sortIcon field="purchaseOrder.subTotal"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="tax">
                                        {{ l('PTax') }}
                                        <p-sortIcon field="purchaseOrder.tax"></p-sortIcon>
                                    </th>
                                    <th style="width: 100px" pSortableColumn="netTotal">
                                        {{ l('PNetTotal') }}
                                        <p-sortIcon field="purchaseOrder.netTotal"></p-sortIcon>
                                    </th>
                                    <!--
                                    <th style="width: 150px" pSortableColumn="grandTotal">
                                        {{ l('PGrandTotal') }}
                                        <p-sortIcon field="purchaseOrder.grandTotal"></p-sortIcon>
                                    </th>
                                    -->
                                    <th style="width: 120px" pSortableColumn="status">
                                        <b>{{ l('Status') }}</b>
                                        <p-sortIcon field="purchaseOrder.status"></p-sortIcon>
                                    </th>
                                    <th style="width: 170px" pSortableColumn="creationTime">
                                        {{ l('CreationTime') }}
                                        <p-sortIcon field="purchaseOrder.creationTime"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                                <tr>
                                    <td
                                        style="width: 5%"
                                        [hidden]="
                                            !isGrantedAny('Pages.PurchaseOrders.Edit', 'Pages.PurchaseOrders.Delete')
                                        "
                                    >
                                        <div class="btn-group dropdown" dropdown container="body">
                                            <button class="dropdown-toggle btn btn-sm btn-primary" dropdownToggle>
                                                <i class="fa fa-cog"></i>
                                                <span class="caret"></span>
                                            </button>
                                            <ul class="dropdown-menu" *dropdownMenu>
                                                <li>
                                                    <a *ngIf="permission.isGranted('Pages.PurchaseOrders.Edit') && record.purchase.status == status.Approved"
                                                       class="dropdown-item"
                                                       [routerLink]="[
                                                            '/app/purchase/purchaseOrders/createOrEdit',
                                                        ]"
                                                       [queryParams]="{ id: record.purchase.id }">
                                                        {{ l('View') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a *ngIf="permission.isGranted('Pages.PurchaseOrders.Edit') && record.purchase.status == status.Draft"
                                                       class="dropdown-item"
                                                       [routerLink]="[
                                                            '/app/purchase/purchaseOrders/createOrEdit',
                                                        ]"
                                                       [queryParams]="{ id: record.purchase.id }">
                                                        {{ l('Edit') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.PurchaseOrders.Draft') && record.purchase.status == status.Approved"
                                                       (click)="convertToDraft(record.purchase)">
                                                        {{ l('ConvertToDraft') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.PurchaseOrders.Approved') && record.purchase.status == status.Draft"
                                                       (click)="convertToApprove(record.purchase)">
                                                        {{ l('ConvertToApproved') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       *ngIf="record.purchase.status == status.Approved"
                                                        [routerLink]="[
                                                            '/app/purchase/purchaseInvoices/createOrEdit',
                                                        ]"
                                                        [queryParams]="{ id: record.purchase.id , dirinv : 0 }"
                                                       >
                                                        {{ l('CreateInvoice') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.PurchaseOrders.Delete')"
                                                       (click)="deletePurchaseOrder(record.purchase)">
                                                        {{ l('Delete') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       (click)="print(record.purchase.id)">
                                                        {{ l('Print') }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style="width: 120px">
                                        <span class="p-column-title">{{ l('PNo') }}</span>
                                        {{ record.purchase.pNo }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('PDate') }}</span>

                                        <span *ngIf="record.purchase.date">
                                            {{ record.purchase.date | luxonFormat: "dd-LLL-yyyy" }}
                                        </span>
                                        <span *ngIf="!record.purchase.date">-</span>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{l('{{Property_Name_Here}}')}}</span>
                                        {{ record.vendorDisplayProperty }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('ReferenceNo') }}</span>
                                        {{ record.purchase.referenceNo }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('PSubTotal') }}</span>
                                        {{ record.purchase.subTotal | priceFormat }}
                                    </td>
                                    <td style="width: 100px" class="text-end">
                                        <span class="p-column-title">{{ l('PTax') }}</span>
                                        {{ record.purchase.tax | priceFormat  }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('PNetTotal') }}</span>
                                        {{ record.purchase.netTotal | priceFormat  }}
                                    </td>
                                    <!--
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('PGrandTotal') }}</span>
                                        {{ record.purchase.grandTotal | priceFormat  }}
                                    </td>
                                    -->
                                    <td style="width: 110px" class="text-center">
                                        <span class="p-column-title">{{ l('Status') }}</span>
                                        <span class="badge" [ngClass]="utilsService.getPaymentStatusBadgeClass(record.purchase.paymentStatus)">
                                                {{ l(status[record.purchase.status]) }}
                                        </span>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('CreationTime') }}</span>

                                        <span *ngIf="record.purchase.creationTime">
                                            {{ record.purchase.creationTime | luxonFormat: "dd-LLL-yyyy HH:mm" }}
                                        </span>
                                        <span *ngIf="!record.purchase.creationTime">-</span>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ l('NoData') }}
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator
                                [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                #paginator
                                (onPageChange)="getPurchaseOrders($event)"
                                [totalRecords]="primengTableHelper.totalRecordsCount"
                                [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                [showCurrentPageReport]="true"
                                [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "
                            ></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>

    <excel-column-selection-modal
        (modalSave)="exportToExcel($event)"
        #excelColumnSelectionModal
    ></excel-column-selection-modal>
</div>
